// extracted by mini-css-extract-plugin
export default {"textStyleWave":"linksTable_textStyleWave__fzPPj","wave":"linksTable_wave__Nw8-t"};